import { primaryDomainHostname } from 'src/constants/hostnameConsts';

export const docsURL = `https://docs.${primaryDomainHostname.prod}`;

export const ClientImportHelpCenterLink = `https://www.${primaryDomainHostname.prod}/guide/client-import`;

export const GET_STARTED_VIDEO_URL = `https://www.${primaryDomainHostname.prod}/university`;
export const API_DOCS_URL = `${docsURL}/reference/`;
export const JOIN_DISCOURSE_COMMUNITY_URL = `https://community.${primaryDomainHostname.prod}/session/sso?return_path=/`;
export const PORTAL_UPDATES_URL = `https://www.${primaryDomainHostname.prod}/updates/`;
export const COPILOT_GUIDE_URL = `https://www.${primaryDomainHostname.prod}/guide`;

export const SUPPORT_EMAIL = `support@${primaryDomainHostname.prod}`;
export const SALES_EMAIL = `sales@${primaryDomainHostname.prod}`;
export const FIND_AN_EXPERT_URL = `https://www.${primaryDomainHostname.prod}/experts`;
export const REQUEST_AN_APP_URL =
  'https://copilotplatforms.typeform.com/to/yfp8IhME';

export const TOS_LINK = `https://www.${primaryDomainHostname.prod}/legal/terms-of-service`;
export const PRIVACY_POLICY_LINK = `https://www.${primaryDomainHostname.prod}/legal/privacy-policy`;
export const PORTAL_URL = `https://www.${primaryDomainHostname.prod}`;
export const DOWNLOAD_APP_URL = `https://www.${primaryDomainHostname.prod}/download`;

// S3 Bucket "portalapp-assets"
export const CDN_BASE_URL = 'https://cdn.assembly.com' as const;
